var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgAware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5733",
    "data-name": "Group 5733",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.594,
    height: 8.681,
    viewBox: "0 0 77.594 8.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 77.594,
    height: 8.681,
    fill: "#505050"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5732",
    "data-name": "Group 5732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M0,3.85H2.534A5.229,5.229,0,0,1,3.988,4a1.553,1.553,0,0,1,.84.684,2.326,2.326,0,0,1,.344,1.291A1.766,1.766,0,0,1,3.926,7.813a2,2,0,0,1,1.5,2.1,2.406,2.406,0,0,1-.592,1.617,2.918,2.918,0,0,1-2.267.69H0ZM1.356,7.322h.877a1.614,1.614,0,0,0,1.221-.34,1.3,1.3,0,0,0,.294-.88,1.1,1.1,0,0,0-.337-.9,1.644,1.644,0,0,0-1.043-.273H1.356Zm0,3.791H2.472q1.534,0,1.534-1.356a1.5,1.5,0,0,0-.325-.945A1.631,1.631,0,0,0,2.356,8.4h-1Z",
    transform: "translate(0 -3.697)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M167.759,58.265h-3.5a2.848,2.848,0,0,0,.34,1.673,1.054,1.054,0,0,0,.853.419q.857,0,1.083-1.153l1.172.153a2.348,2.348,0,0,1-4.086,1.166,3.6,3.6,0,0,1-.669-2.356,3.949,3.949,0,0,1,.675-2.466,2.166,2.166,0,0,1,1.8-.871,2.052,2.052,0,0,1,1.331.436,2.316,2.316,0,0,1,.761,1.144,6.765,6.765,0,0,1,.239,1.856m-1.307-.865q0-1.638-1.067-1.638-1,0-1.1,1.638Z",
    transform: "translate(-156.458 -52.645)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M307.767,4.233h2.8V8.589h-.74l-.185-1.061a2.138,2.138,0,0,1-2.014,1.153,2.521,2.521,0,0,1-2.192-1.138,5.336,5.336,0,0,1-.79-3.089,5.905,5.905,0,0,1,.781-3.255,2.664,2.664,0,0,1,2.4-1.2q2.255,0,2.7,2.552l-1.251.313a2.58,2.58,0,0,0-.594-1.4,1.315,1.315,0,0,0-.882-.319q-1.684,0-1.684,3.184,0,3.2,1.723,3.2,1.43,0,1.43-2.19h-1.5Z",
    transform: "translate(-292.509 0)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M481.529,56.731l-1.233-.153a1.849,1.849,0,0,1,.763-1.288,2.621,2.621,0,0,1,1.571-.46,2.361,2.361,0,0,1,1.333.334,1.432,1.432,0,0,1,.628.794,5.577,5.577,0,0,1,.129,1.393v2.11a8.394,8.394,0,0,0,.11,1.712h-1.209a4.865,4.865,0,0,1-.08-1.031,1.859,1.859,0,0,1-1.739,1.184,1.687,1.687,0,0,1-1.259-.482,1.784,1.784,0,0,1-.475-1.31,1.988,1.988,0,0,1,.7-1.6,3.775,3.775,0,0,1,2.41-.589q.086,0,.269.006V57.1a2.008,2.008,0,0,0-.2-1,.757.757,0,0,0-.712-.337q-.838,0-1,.969m1.914,1.423q-.245-.024-.373-.025-1.664,0-1.664,1.307,0,.951.826.951a1.036,1.036,0,0,0,.847-.515,2.42,2.42,0,0,0,.364-1.417Z",
    transform: "translate(-460.946 -52.645)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M632.854,54.977h1.178v.945a1.565,1.565,0,0,1,1.526-1.092,1.307,1.307,0,0,1,1.416,1.153,1.578,1.578,0,0,1,1.569-1.153,1.691,1.691,0,0,1,.941.245,1.285,1.285,0,0,1,.524.65,5.215,5.215,0,0,1,.147,1.528v3.92h-1.276V57.362a3.123,3.123,0,0,0-.151-1.189.606.606,0,0,0-.606-.312q-.973,0-.973,1.685v3.628h-1.276V57.4a5.074,5.074,0,0,0-.064-1.039.678.678,0,0,0-.239-.371.717.717,0,0,0-.451-.135.8.8,0,0,0-.761.4,2.817,2.817,0,0,0-.227,1.314v3.6h-1.276Z",
    transform: "translate(-607.646 -52.646)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M853.1,3.85h1.276V6.74a1.654,1.654,0,0,1,1.436-.822,1.751,1.751,0,0,1,1.525.825,3.909,3.909,0,0,1,.559,2.224q0,3.387-2.288,3.386a1.508,1.508,0,0,1-1.5-.969,8.639,8.639,0,0,0-.284.84H853.1ZM854.372,9.6q0,1.783,1.086,1.783a.853.853,0,0,0,.817-.539,4.565,4.565,0,0,0,.256-1.807,3.954,3.954,0,0,0-.256-1.7.843.843,0,0,0-.793-.481.956.956,0,0,0-.79.429,1.893,1.893,0,0,0-.32,1.158Z",
    transform: "translate(-819.115 -3.697)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 1.276,
    height: 8.374,
    transform: "translate(39.981 0.153)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M1070.6,58.265h-3.5a2.847,2.847,0,0,0,.34,1.673,1.055,1.055,0,0,0,.854.419q.857,0,1.083-1.153l1.172.153a2.348,2.348,0,0,1-4.086,1.166,3.6,3.6,0,0,1-.669-2.356,3.95,3.95,0,0,1,.675-2.466,2.166,2.166,0,0,1,1.8-.871,2.052,2.052,0,0,1,1.331.436,2.314,2.314,0,0,1,.761,1.144,6.755,6.755,0,0,1,.239,1.856M1069.3,57.4q0-1.638-1.068-1.638-1,0-1.1,1.638Z",
    transform: "translate(-1023.34 -52.645)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M1254.27,3.85h1.554l2.248,8.374h-1.4l-.525-2.1h-2.455l-.521,2.1h-1.322Zm1.6,5.184-.96-3.834-.951,3.834Z",
    transform: "translate(-1201.98 -3.697)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M1408.635,58.526h1.259l.922,4.258.89-4.258h1.123l.883,4.282.983-4.282h1.038l-1.536,6.2h-1.086l-.939-4.294-.9,4.294h-1.087Z",
    transform: "translate(-1352.525 -56.195)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M1597.686,56.731l-1.233-.153a1.848,1.848,0,0,1,.763-1.288,2.621,2.621,0,0,1,1.572-.46,2.362,2.362,0,0,1,1.333.334,1.432,1.432,0,0,1,.628.794,5.581,5.581,0,0,1,.129,1.393v2.11a8.392,8.392,0,0,0,.11,1.712h-1.209a4.857,4.857,0,0,1-.08-1.031,1.859,1.859,0,0,1-1.74,1.184,1.687,1.687,0,0,1-1.258-.482,1.785,1.785,0,0,1-.475-1.31,1.988,1.988,0,0,1,.7-1.6,3.774,3.774,0,0,1,2.41-.589q.086,0,.27.006V57.1a2,2,0,0,0-.2-1,.756.756,0,0,0-.712-.337q-.837,0-1,.969m1.914,1.423c-.163-.016-.287-.025-.373-.025q-1.664,0-1.664,1.307,0,.951.826.951a1.035,1.035,0,0,0,.847-.515,2.419,2.419,0,0,0,.364-1.417Z",
    transform: "translate(-1532.643 -52.645)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M1749.011,55.421h1.123v1.387q.517-1.515,1.551-1.515a1.773,1.773,0,0,1,.234.018v1.331a2.377,2.377,0,0,0-.258-.018q-1.373,0-1.373,1.841v3.153h-1.276Z",
    transform: "translate(-1679.343 -53.09)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M1832.061,58.265h-3.5a2.845,2.845,0,0,0,.34,1.673,1.054,1.054,0,0,0,.854.419q.856,0,1.083-1.153l1.172.153a2.348,2.348,0,0,1-4.086,1.166,3.6,3.6,0,0,1-.669-2.356,3.948,3.948,0,0,1,.675-2.466,2.165,2.165,0,0,1,1.8-.871,2.052,2.052,0,0,1,1.332.436,2.315,2.315,0,0,1,.76,1.144,6.767,6.767,0,0,1,.24,1.856m-1.307-.865q0-1.638-1.067-1.638-1,0-1.1,1.638Z",
    transform: "translate(-1754.466 -52.645)",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAware);
export default __webpack_public_path__ + "static/media/bg-aware.e7c5e68c4cd7df0691eb260008176a03.svg";
export { ForwardRef as ReactComponent };